import APIV2 from "../api/managerV2";
import config from "../api/config";

const GetClientMappedSourcesForUserv3 = (clientId = 0) => {
  return APIV2(
    {
      method: "GET",
      url: `${config.urls.auth.clientSources}?clientId=${clientId}`
    },
    true
  );
}

const GetClientMappedProficiencySchemesForUserv3 = (clientId = 0) => {
  return APIV2(
    {
      method: "GET",
      url: `${config.urls.auth.clientProficiencySchemes}?clientId=${clientId}`
    },
    true
  );
}

export const ClientService = {
    GetClientMappedSourcesForUserv3,
    GetClientMappedProficiencySchemesForUserv3
}